import { useEffect } from "react";
import gsap from "gsap";
import { useSceneStore } from "@/state/useSceneStore";

const isTypingTarget = (t: EventTarget | null): boolean => {
  if (!(t instanceof HTMLElement)) return false;
  const tag = t.tagName.toLowerCase();
  return tag === "input" || tag === "textarea" || t.isContentEditable;
};

export const Keyboard = (): null => {
  const mesh = useSceneStore((s) => s.objects.keyboard);

  useEffect(() => {
    if (!mesh) return;
    const onKey = (e: KeyboardEvent): void => {
      if (isTypingTarget(e.target)) return;
      const keys = mesh.children;
      if (keys.length === 0) return;
      const idx = Math.floor(Math.random() * keys.length);
      const target = keys[idx];
      if (!target) return;
      const baseY = target.position.y;
      gsap.to(target.position, {
        y: baseY - 0.002,
        duration: 0.08,
        yoyo: true,
        repeat: 1,
        ease: "power2.out",
        onComplete: () => {
          target.position.y = baseY;
        },
      });
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [mesh]);

  return null;
};
